var Immutable = require('immutable');
var Content = require('../models/content');

/**
 * Walk throught the children tokens tree, and
 * map each token using a transformation
 *
 * The transformation iterator can return a list, a new token or undefined.
 *
 * @param {Token|Content} base
 * @param {Function(token, depth)} iter
 * @param {Number} depth
 * @return {Token}
 */
function transformToken(base, iter, depth) {
    depth = depth || 0;
    var tokens = base.getTokens();
    var newTokens = transformTokens(tokens, iter, depth);
    base = base.set('tokens', newTokens);

    return (base instanceof Content)? base : iter(base, depth);
}

/**
 * Transform a list of tokens
 * @param {List<Token>} tokens
 * @param {Function} iter
 * @param {Number} depth
 * @return {List<Token>}
 */
function transformTokens(tokens, iter, depth) {
    return tokens
        .reduce(function(list, token) {
            var result = transform(token, iter, depth + 1);

            if (Immutable.List.isList(result)) {
                return list.concat(result);
            }
            else if (result) {
                return list.push(result);
            }

            return list;
        }, Immutable.List());
}


/**
 * Transform that works on token or list of tokens
 * @param  {Token|List<Token>|Content} base
 * @param  {Function} iter
 * @return {Token|List<Token>|Content}
 */
function transform(base, iter) {
    if (Immutable.List.isList(base)) {
        return transformTokens(base, iter);
    } else {
        return transformToken(base, iter);
    }
}

module.exports = transform;



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/utils/transform.js
// module id = 807
// module chunks = 0